import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goToCheckout = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Guía Informativa',
        content_type: 'product',
        value: 27.0,
        currency: 'USD'
      });
    }
    window.open('https://tiendadelibrosdigital.com/cart/42545816797255:1', '_blank');
  };
  return <section className="relative w-full bg-gradient-to-b from-[#0F1D33] to-[#1B2A4A] overflow-hidden py-16 md:py-24" data-id="element-64">
      {/* Decorative gold lines */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-65">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full border border-[#C5A55A]/20 blur-sm" data-id="element-66" />
        <div className="absolute bottom-[10%] -right-[10%] w-[40%] h-[60%] rounded-full border border-[#C5A55A]/20 blur-sm" data-id="element-67" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-68">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-69">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-70">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="inline-block mb-4 px-4 py-1.5 rounded-full border border-[#C5A55A]/40 bg-[#C5A55A]/10 text-[#E8D5A3] text-sm font-medium tracking-wider uppercase" data-id="element-71">
              Edición 2026 · Nueva Era
            </motion.div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#C5A55A] mb-6 drop-shadow-sm" data-id="element-72">
              Guía Informativa
            </h1>

            <p className="text-xl md:text-2xl text-white/90 mb-10 font-light leading-relaxed" data-id="element-73">
              El plan paso a paso para que la mujer hispana en USA asegure cada
              dólar que le corresponde legalmente,{' '}
              <strong className="text-[#E8D5A3] font-semibold" data-id="element-74">
                sin errores y sin depender de traductores.
              </strong>
            </p>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={goToCheckout} className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#C5A55A] hover:bg-[#b39550] text-[#0F1D33] text-lg md:text-xl font-bold py-5 px-8 rounded-full shadow-[0_0_20px_rgba(197,165,90,0.4)] transition-all duration-300" aria-label="Comprar la guía informativa" data-id="element-75">
              SÍ, QUIERO MI GUÍA INFORMATIVA
              <ChevronRight className="w-6 h-6" data-id="element-76" />
            </motion.button>

            <p className="mt-4 text-[#E8D5A3]/70 text-sm flex items-center justify-center lg:justify-start gap-2" data-id="element-77">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-78" />
              Actualizado para las leyes de 2026
            </p>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-79">
            <div className="relative aspect-[4/3] lg:aspect-square w-full" data-id="element-80">
              <div className="w-full h-full rounded-2xl bg-gradient-to-br from-[#1a2744] via-[#1e3050] to-[#0F1D33] border-2 border-[#C5A55A]/50 shadow-[0_0_40px_rgba(197,165,90,0.15)] flex flex-col items-center justify-center p-8 overflow-hidden relative" data-id="element-81">
                {/* Corner accents */}
                <div className="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2 border-[#C5A55A]/60" data-id="element-82" />
                <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-[#C5A55A]/60" data-id="element-83" />
                <div className="absolute bottom-4 left-4 w-8 h-8 border-b-2 border-l-2 border-[#C5A55A]/60" data-id="element-84" />
                <div className="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2 border-[#C5A55A]/60" data-id="element-85" />

                {/* Decorative line */}
                <div className="w-16 h-0.5 bg-[#C5A55A]/60 mb-6" data-id="element-86" />

                {/* Icon */}
                <div className="w-16 h-16 mb-6 rounded-full border-2 border-[#C5A55A]/50 flex items-center justify-center" data-id="element-87">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-[#C5A55A]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} data-id="element-88">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" data-id="element-89" />
                  </svg>
                </div>

                {/* Title */}
                <h2 className="text-2xl md:text-3xl font-bold text-[#C5A55A] text-center leading-tight mb-3 tracking-wide" data-id="element-90">
                  GUÍA INFORMATIVA
                </h2>
                <p className="text-base md:text-lg text-[#E8D5A3]/80 text-center font-medium leading-snug mb-6 max-w-[280px]" data-id="element-91">
                  Para Documentarse Correctamente
                </p>

                {/* Decorative line */}
                <div className="w-16 h-0.5 bg-[#C5A55A]/60 mb-6" data-id="element-92" />

                {/* Subtitle */}
                <p className="text-xs text-[#E8D5A3]/50 uppercase tracking-[0.25em] text-center" data-id="element-93">
                  Edición 2026
                </p>

                {/* Subtle background pattern */}
                <div className="absolute inset-0 opacity-[0.03]" style={{
                backgroundImage: 'radial-gradient(circle, #C5A55A 1px, transparent 1px)',
                backgroundSize: '20px 20px'
              }} data-id="element-94" />
              </div>
            </div>
            {/* Glow effect behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#C5A55A]/20 blur-[100px] -z-10 rounded-full" data-id="element-95" />
          </motion.div>
        </div>
      </div>
    </section>;
}